import styled from "styled-components";
import { focusStyle } from "../../styles/v2/toyota/utilities/Focus";

export const InternalLink = styled.a`
    ${focusStyle};
`;

export default InternalLink;
